import { useState} from 'react'
import { consumirApi } from '../../utils/consumoApi'
import ErrorAlert from '../../components/common/ErrorAlert'
import Form from '../../components/forms/Form'
import Input from '../../components/common/Input'
import Notification from '../../components/common/Notification'


const ClaveUsuario = () => {
  const [claveActual, setClaveActual] = useState('')
  const [claveNueva, setClaveNueva] = useState('')

  const [error, setError] = useState("")
  const [notificacion, setNotificacion] = useState({ estado: false, tipo: "", mensaje: "" })

  const enviarEdicionClave = async (e) => {
    e.preventDefault()
    setError('')
    try {
      const data = { old_password: claveActual, new_password: claveNueva }
      const respuesta = await consumirApi('PATCH', `users/user/change-password`, data)
      if (respuesta.success) {
        setNotificacion({ estado: true, tipo: "actualizacion", mensaje: "Clave actualizada correctamente" })
        setClaveActual('')
        setClaveNueva('')
      } else {
        setError(respuesta.error)
      }
    } catch (error) {
      console.error(error)
    }
  }

  return (

    <div className="flex gap-3 w-full bg-gray-100">
      {notificacion.estado && (
        <Notification estadoNotificacion={setNotificacion} type={notificacion.tipo} mensaje={notificacion.mensaje} />
      )}
      <div className="bg-white shadow-lg rounded-lg p-6 max-w-sm">
        <Form onSubmit={enviarEdicionClave}  type="update">
          <Input name="clave_actual" value={claveActual} label="Clave actual" onChange={setClaveActual} />
          <Input name="clave_nueva" value={claveNueva} label="Nueva Clave" onChange={setClaveNueva} />
          {error && <ErrorAlert message={error} />}
        </Form>
      </div>
    </div >

  )
}

export default ClaveUsuario
